import { a as addToCartFromCard } from "./section-main-cart.js";
import "./component-drawer.js";
import "./component-quantity.js";
import "./utilities-utils.js";
import "./utilities-sticky-engine.js";
import "./utilities-truncatable.js";
import "./utilities-nav-utils.js";
import "./utilities-overlay.js";
import "./utilities-toggletip-engine.js";
import "./floating-ui.js";
function loadIcons() {
  document.querySelectorAll(".icon").forEach((icon) => {
    icon.classList.add("loaded");
  });
}
function initScrollAnimations() {
  if (!("IntersectionObserver" in window)) {
    document.querySelectorAll(".shopify-section").forEach((section) => {
      section.querySelector(".section__wrapper")?.classList.add("in-view");
    });
    return;
  }
  const observerOptions = {
    threshold: 0.01,
    // Trigger when 1% of element is visible
    rootMargin: "0px 0px -50px 0px"
    // Trigger 50px before element enters viewport
  };
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.querySelector(".section__wrapper")?.classList.add("in-view");
        const images = entry.target.querySelectorAll("img:not(.image-loaded):not(.no-animate):not([data-no-animate])");
        images.forEach((img) => {
          if (!img.closest(".no-animate")) {
            animateImageDelayed(img);
          }
        });
      }
    });
  }, observerOptions);
  document.querySelectorAll(".shopify-section").forEach((section) => {
    observer.observe(section);
  });
}
if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", (event) => {
    initScrollAnimations();
  });
}
function initImageAnimations() {
  function animateImage(img) {
    if (img.classList.contains("image-loaded") || img.classList.contains("no-animate") || img.hasAttribute("data-no-animate") || img.closest(".no-animate")) {
      return;
    }
    const parentSection = img.closest(".shopify-section");
    if (parentSection && !parentSection.classList.contains("in-view")) {
      return;
    }
    if (img.complete && img.naturalHeight !== 0) {
      img.classList.add("image-loaded");
    } else {
      const handleLoad = () => {
        img.classList.add("image-loaded");
        img.removeEventListener("load", handleLoad);
        img.removeEventListener("error", handleLoad);
      };
      img.addEventListener("load", handleLoad);
      img.addEventListener("error", handleLoad);
    }
  }
  window.animateImageDelayed = function(img) {
    if (img.classList.contains("image-loaded") || img.classList.contains("no-animate") || img.hasAttribute("data-no-animate") || img.closest(".no-animate")) {
      return;
    }
    if (img.complete && img.naturalHeight !== 0) {
      img.classList.add("image-loaded");
    } else {
      const handleLoad = () => {
        img.classList.add("image-loaded");
        img.removeEventListener("load", handleLoad);
        img.removeEventListener("error", handleLoad);
      };
      img.addEventListener("load", handleLoad);
      img.addEventListener("error", handleLoad);
    }
  };
  document.querySelectorAll("img").forEach(animateImage);
  const imageObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          if (node.tagName === "IMG") {
            animateImage(node);
          }
          node.querySelectorAll && node.querySelectorAll("img").forEach(animateImage);
        }
      });
    });
  });
  imageObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
  if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", () => {
      setTimeout(() => {
        document.querySelectorAll("img:not(.image-loaded)").forEach(animateImage);
      }, 50);
    });
  }
}
document.addEventListener("DOMContentLoaded", function() {
  initScrollAnimations();
  initImageAnimations();
});
document.addEventListener("DOMContentLoaded", function() {
  loadIcons();
  document.querySelectorAll('a[target="_blank"]').forEach((el) => {
    el.innerHTML = el.innerHTML + '<span class="visually-hidden"> ' + accessibilityNoticeNewTab + "</span>";
  });
  addToCartFromCard();
});
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}
Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  };
};
Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};
Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent("on" + eventName, callback);
};
Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};
  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);
  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};
Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );
  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );
  this.initCountry();
  this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },
  initProvince: function() {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },
  countryHandler: function(e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);
    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }
      this.provinceContainer.style.display = "";
    }
  },
  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },
  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};
function playPauseHostedVideo() {
  let videos = document.querySelectorAll("video");
  videos.forEach((video) => {
    video.muted = true;
    let observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            video.pause();
          } else if (video.autoplay == true) {
            if (video.paused) {
              video.play().catch((error) => {
                if (error.name !== "AbortError") {
                  console.error("Error playing video:", error);
                }
              });
            }
          }
        });
      },
      { threshold: 0 }
    );
    observer.observe(video);
  });
  let hoverPlayVideos = document.querySelectorAll("video.hover-play");
  hoverPlayVideos.forEach((video) => {
    const card = video.closest(".card");
    video.pause();
    if (card) {
      card.addEventListener("mouseenter", () => {
        video.play().catch((error) => {
          if (error.name !== "AbortError") {
            console.error("Error playing video:", error);
          }
        });
      });
      card.addEventListener("mouseleave", () => {
        video.pause();
      });
    } else {
      video.addEventListener("mouseenter", () => {
        video.play().catch((error) => {
          if (error.name !== "AbortError") {
            console.error("Error playing video:", error);
          }
        });
      });
      video.addEventListener("mouseleave", () => {
        video.pause();
      });
    }
  });
}
playPauseHostedVideo();
const enableLazyVideos = function() {
  const lazyVideos = [].slice.call(document.querySelectorAll("video"));
  lazyVideos.forEach((lazyVideo) => {
    const poster = lazyVideo.parentElement.querySelector(
      ".figure--video__poster"
    );
    if (poster) {
      poster.addEventListener("click", () => {
        poster.classList.add("hidden");
        lazyVideo.play();
      });
    }
  });
  var externalVideos = [].slice.call(
    document.querySelectorAll(".figure--video-external")
  );
  if ("IntersectionObserver" in window) {
    var externalVideoObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(container) {
        if (container.isIntersecting) {
          let videoType = container.target.dataset.type;
          if (videoType == "vimeo") {
            fetch(
              "http://vimeo.com/api/v2/video/" + container.target.dataset.id + ".json"
            ).then((response) => {
              if (!response.ok) {
                throw new Error(`HTTP error ${response.status}`);
              }
              return response.json();
            }).then((data) => {
              container.target.querySelector(
                ".figure--video__external-poster-image"
              ).src = data[0].thumbnail_large;
            });
          }
          container.target.addEventListener("click", function() {
            if (!container.target.querySelector("iframe")) {
              let videoType2 = this.dataset.type;
              let iframe = document.createElement("iframe");
              iframe.setAttribute("frameborder", "0");
              iframe.setAttribute("allowfullscreen", "");
              iframe.setAttribute("allow", "autoplay");
              if (videoType2 == "youtube") {
                iframe.setAttribute("id", "youtube");
                iframe.setAttribute(
                  "src",
                  "https://www.youtube.com/embed/" + this.dataset.id + this.dataset.videotags + "rel=0&showinfo=0&autoplay=1&enablejsapi=1"
                );
              } else {
                iframe.setAttribute(
                  "src",
                  "https://player.vimeo.com/video/" + this.dataset.id + this.dataset.videotags + "rel=0&showinfo=0&autoplay=1"
                );
              }
              this.appendChild(iframe);
              setTimeout(() => {
                this.querySelector(".figure--video__poster").classList.add(
                  "hidden"
                );
              }, 350);
            }
          });
        } else {
          if (container.target.querySelector("iframe")) {
            let videoType = container.target.dataset.type;
            let iframe = container.target.querySelectorAll("iframe");
            if (videoType == "youtube") {
              var command = {
                event: "command",
                func: "pauseVideo"
              };
              iframe[0].contentWindow.postMessage(JSON.stringify(command), "*");
            } else if (videoType == "vimeo") {
              var command = {
                method: "pause",
                value: "true"
              };
              iframe[0].contentWindow.postMessage(JSON.stringify(command), "*");
            }
          }
        }
      });
    });
    externalVideos.forEach(function(externalVideo) {
      externalVideoObserver.observe(externalVideo);
    });
  }
};
enableLazyVideos();
window.addEventListener("beforeprint", () => {
  const allDetails = document.body.querySelectorAll("details");
  const allImages = document.body.querySelectorAll("img");
  for (let i = 0; i < allDetails.length; i++) {
    if (allDetails[i].open) {
      allDetails[i].dataset.open = "1";
    } else {
      allDetails[i].setAttribute("open", "");
    }
  }
  for (let i = 0; i < allImages.length; i++) {
    allImages[i].dataset.open = "1";
  }
});
window.addEventListener("afterprint", () => {
  const allDetails = document.body.querySelectorAll("details");
  for (let i = 0; i < allDetails.length; i++) {
    if (allDetails[i].dataset.open) {
      allDetails[i].dataset.open = "";
    } else {
      allDetails[i].removeAttribute("open");
    }
  }
});
if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", () => {
    enableLazyVideos();
    document.querySelectorAll(".icon").forEach((icon) => {
      icon.classList.add("loaded");
    });
  });
}
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", (event) => {
      const syncEvent = new CustomEvent("variant-update", {
        detail: { event, section: this.dataset.section, product: this.dataset.product, block: this.dataset.block },
        bubbles: true
      });
      this.dispatchEvent(syncEvent);
    });
    document.addEventListener("variant-update", (e) => {
      if (this.dataset.section === e.detail.section && this.dataset.product === e.detail.product && this.dataset.block === e.detail.block) {
        if (e.detail.event.target.closest("variant-selects") !== this) {
          this.syncSelection(e.detail.event.target);
        }
        this.onVariantChange();
      }
    });
    this.isCardBasedProductForm = this.closest(".card__content") !== null;
  }
  connectedCallback() {
    this.mainProductUniqueIdentifier = "main-product-" + this.dataset.product;
    this.uniqueIdentifier = this.dataset.section + "-" + this.dataset.product + (this.dataset.block ? "-" + this.dataset.block : "");
    this.updateSwatchLegend();
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    if (this.currentVariant) {
      this.updateVariantStatuses();
      this.updateMedia();
      this.updateURL();
      this.updateLinks();
      this.renderProductInfo();
      this.updateVariantInput();
      this.updateAddToCart();
      this.updateSwatchLegend();
    } else if (this.currentVariant === void 0) {
      this.setUnavailable();
    }
  }
  updateSwatchLegend() {
    const fieldsets = this.querySelectorAll(".main-product__fieldset--image_swatches, .main-product__fieldset--color_swatches, .main-product__fieldset--pills");
    fieldsets.forEach((fieldset) => {
      const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
      const legend = fieldset.querySelector("legend");
      if (legend) {
        const optionName = legend.dataset.optionName || legend.textContent.split(":")[0].trim();
        if (checkedInput) {
          const label = checkedInput.closest("label");
          const value = label ? label.getAttribute("title") : checkedInput.value;
          legend.textContent = `${optionName}: ${value}`;
        } else {
          legend.textContent = optionName;
        }
      }
    });
  }
  syncSelection(target) {
    const { name, value } = target;
    const inputElement = this.querySelector(`[name="${name}"]`);
    const inputElementTagName = inputElement?.tagName;
    if (!inputElement) return;
    if (inputElementTagName === "SELECT") {
      this.querySelector(`[name="${name}"] [value="${value}"]`).selected = true;
    } else {
      this.querySelector(`[name="${name}"][value="${value}"]`).checked = true;
    }
  }
  updateOptions() {
    this.options = Array.from(this.querySelectorAll("select, fieldset"), (element) => {
      if (element.tagName === "SELECT") {
        return element.value;
      } else if (element.tagName === "FIELDSET") {
        return Array.from(element.querySelectorAll("input")).find((radio) => radio.checked)?.value;
      }
    });
  }
  updateMasterId() {
    if (this.options.includes(void 0)) {
      this.currentVariant = null;
      return;
    }
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }
  updateVariantStatuses() {
    const selectedOptionOne = this.querySelector(":checked").value;
    const selectedOptionOneVariants = this.getVariantData().filter((variant) => {
      return variant.options[0] === selectedOptionOne;
    });
    const productVariantSelects = this.getProductVariantSelects();
    productVariantSelects.forEach((variantSelectElement) => {
      const variantSelectInputElements = variantSelectElement.querySelectorAll("select, fieldset");
      variantSelectInputElements.forEach((variantSelectInputElement, index) => {
        if (index === 0) return;
        const optionInputs = variantSelectInputElement.querySelectorAll(
          'input[type="radio"], option'
        );
        const previousOptionSelected = variantSelectInputElements[index - 1].querySelector(":checked").value;
        const availableOptionInputsValue = selectedOptionOneVariants.filter(
          (variant) => variant.available && variant[`option${index}`] === previousOptionSelected
        ).map((variantOption) => variantOption[`option${index + 1}`]);
        this.setInputAvailability(optionInputs, availableOptionInputsValue);
      });
    });
  }
  setInputAvailability(optionInputs, availableValuesList) {
    optionInputs.forEach((element) => {
      const value = element.getAttribute("value");
      const availableElement = availableValuesList.includes(value);
      if (element.tagName === "OPTION") {
        element.innerText = availableElement ? value : window.productStrings.unavailable_with_option.replace("[value]", value);
      }
    });
  }
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const productGallery = document.querySelector(`#gallery-${this.uniqueIdentifier}`);
    const variantGalleryStyle = productGallery?.dataset?.variantStyle || "default";
    if (this.currentVariant.featured_media) {
      const currentVariantFeaturedMediaId = this.currentVariant.featured_media.id;
      if (variantGalleryStyle == "default") {
        if (productGallery && productGallery.swiper && productGallery.swiper.initialized) {
          const slides = productGallery.swiper.virtual.slides.length > 0 ? productGallery.swiper.virtual.slides : productGallery.swiper.slides;
          const index = Array.from(slides).findIndex(
            (slide) => slide.dataset.id == currentVariantFeaturedMediaId
          );
          if (index !== -1) {
            productGallery.swiper.slideToLoop(index);
          }
        } else {
          const targetSlide = productGallery.querySelector(
            `[data-id="${currentVariantFeaturedMediaId}"]`
          );
          if (targetSlide) {
            productGallery.prepend(targetSlide);
          }
        }
      } else if (variantGalleryStyle == "variant") {
        const targetSlide = productGallery.querySelector(
          `[data-id="${currentVariantFeaturedMediaId}"]`
        );
        if (targetSlide) {
          productGallery.firstChild.classList.add("u-hide");
          targetSlide.classList.remove("u-hide");
          productGallery.prepend(targetSlide);
        }
      }
      const stickyProductGallery = document.querySelector(
        `#sticky-gallery-${this.uniqueIdentifier}`
      );
      if (stickyProductGallery) {
        const stickyImages = stickyProductGallery.querySelectorAll(".sticky-add-to-cart__image");
        const variantId = this.currentVariant.id;
        stickyImages.forEach((imgElement) => {
          if (imgElement.dataset.variantId == variantId) {
            imgElement.classList.remove("u-hide");
          } else {
            imgElement.classList.add("u-hide");
          }
        });
      }
    }
  }
  updateURL() {
    if (this.dataset.updateUrl === "false") return;
    const newURL = `${this.dataset.url}?variant=${this.currentVariant.id}`;
    window.history.replaceState({}, "", newURL);
  }
  updateLinks() {
    if (!this.isCardBasedProductForm) return;
    const viewProductButton = this.closest(".card__content").querySelector(".button--view-product");
    if (viewProductButton?.tagName === "A") {
      viewProductButton.href = this.dataset.url.split("?")[0] + `?variant=${this.currentVariant.id}`;
    }
  }
  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#form-product-${this.uniqueIdentifier}, #form-product-installment-${this.uniqueIdentifier}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }
  renderProductInfo() {
    const priceDestination = document.getElementById(`price-${this.uniqueIdentifier}`);
    if (priceDestination) {
      if (priceDestination.classList.contains("price--on-sale")) {
        priceDestination.querySelectorAll(".price__sale .price-item").forEach((el) => el.classList.add("skeleton-loading"));
      } else {
        priceDestination.querySelector(".price__regular").classList.add("skeleton-loading");
      }
    }
    const stickyPriceDestination = document.getElementById(`sticky-price-${this.uniqueIdentifier}`);
    if (stickyPriceDestination) {
      if (stickyPriceDestination.classList.contains("price--on-sale")) {
        stickyPriceDestination.querySelectorAll(".price__sale .price-item").forEach((el) => el.classList.add("skeleton-loading"));
      } else {
        stickyPriceDestination.querySelector(".price__regular").classList.add("skeleton-loading");
      }
    }
    const pickupDestination = document.getElementById(
      `pickup-availability-${this.uniqueIdentifier}`
    );
    pickupDestination?.querySelector(".skeleton-loading-wrapper")?.classList.add("skeleton-loading");
    const stockStatusDestination = document.getElementById(`stock-status-${this.uniqueIdentifier}`);
    stockStatusDestination?.classList.add("skeleton-loading");
    const pickupModalDestination = document.getElementById(
      `pickup-availability-modal-${this.mainProductUniqueIdentifier}`
    );
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}`).then((response) => response.text()).then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, "text/html");
      const priceSource = html.getElementById(`price-${this.mainProductUniqueIdentifier}`);
      if (stockStatusDestination) {
        const stockStatusSource = html.getElementById(
          `stock-status-${this.mainProductUniqueIdentifier}`
        );
        if (stockStatusSource) {
          stockStatusDestination.classList.remove("u-invisible");
          stockStatusDestination.innerHTML = stockStatusSource.innerHTML;
          stockStatusDestination.classList = stockStatusSource.classList;
        } else {
          stockStatusDestination?.classList.add("u-invisible");
        }
      }
      if (priceSource && priceDestination) {
        priceDestination.classList.remove("u-invisible");
        priceDestination.innerHTML = priceSource.innerHTML;
        priceDestination.classList = priceSource.classList;
      } else {
        priceDestination?.classList.add("u-invisible");
      }
      if (stickyPriceDestination) {
        const stickyPriceSource = html.getElementById(
          `sticky-price-${this.mainProductUniqueIdentifier}`
        );
        if (stickyPriceSource) {
          stickyPriceDestination.classList.remove("u-invisible");
          stickyPriceDestination.innerHTML = stickyPriceSource.innerHTML;
          stickyPriceDestination.classList = stickyPriceSource.classList;
        } else {
          stickyPriceDestination?.classList.add("u-invisible");
        }
      }
      if (pickupDestination) {
        const pickupSource = html.getElementById(
          `pickup-availability-${this.mainProductUniqueIdentifier}`
        );
        if (pickupSource) {
          pickupDestination.innerHTML = pickupSource.innerHTML;
          pickupDestination.classList = pickupSource.classList;
        }
      }
      if (pickupModalDestination) {
        const pickupModalSource = html.getElementById(
          `pickup-availability-modal-${this.mainProductUniqueIdentifier}`
        );
        if (pickupModalSource) {
          pickupModalDestination.innerHTML = pickupModalSource.innerHTML;
        }
      }
      document.dispatchEvent(new CustomEvent("drawer:reinitialize"));
    });
  }
  updateAddToCart() {
    const productForm = document.querySelectorAll(`.form-product-${this.uniqueIdentifier}`);
    if (!productForm) return;
    if (this.currentVariant.available) {
      productForm.forEach((form) => {
        const addButton = form.querySelector('[name="add"]');
        const addButtonText = form.querySelector('[name="add"] > span:not(.cart-icon)');
        if (!addButton) return;
        addButton.removeAttribute("disabled");
        addButtonText.textContent = `${cartStrings.addToCart}`;
      });
    } else {
      productForm.forEach((form) => {
        const addButton = form.querySelector('[name="add"]');
        const addButtonText = form.querySelector('[name="add"] > span:not(.cart-icon)');
        if (!addButton) return;
        addButton.setAttribute("disabled", "disabled");
        addButtonText.textContent = `${cartStrings.soldOut}`;
      });
    }
  }
  setUnavailable() {
    const productForm = document.querySelectorAll(
      `.form-product-${this.uniqueIdentifier}`
    );
    const stock = document.getElementById(
      `stock-status-${this.uniqueIdentifier}`
    );
    productForm.forEach((form) => {
      const addButton = form.querySelector('[name="add"]');
      const addButtonText = form.querySelector(
        '[name="add"] > span:not(.cart-icon)'
      );
      if (!addButton) return;
      addButtonText.textContent = `${cartStrings.unavailable}`;
      addButton.setAttribute("disabled", "disabled");
      if (stock) stock.dataset.state = "unavailable";
    });
    const price = document.getElementById(`price-${this.uniqueIdentifier}`);
    const stickyPrice = document.getElementById(`sticky-price-${this.uniqueIdentifier}`);
    if (price) this.setPriceUnavailable(price);
    if (stickyPrice) this.setPriceUnavailable(stickyPrice);
  }
  setPriceUnavailable(priceElement) {
    priceElement.classList.remove("price--on-sale");
    priceElement.classList.add("price--sold-out");
    priceElement.querySelector(".price__regular .price-item.price-item--regular").textContent = window.productStrings.price_unavailable;
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
  getProductVariantSelects() {
    return document.querySelectorAll(
      `variant-selects[data-section="${this.dataset.section}"][data-product="${this.dataset.product}"][data-block="${this.dataset.block}"]`
    );
  }
}
if (!customElements.get("variant-selects")) {
  customElements.define("variant-selects", VariantSelects);
}
class Accordion {
  constructor(el) {
    this.el = el;
    this.summary = el.querySelector("summary");
    this.content = el.querySelector(".content");
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.summary.addEventListener("click", (e) => this.onClick(e));
  }
  onClick(e) {
    e.preventDefault();
    this.el.style.overflow = "hidden";
    if (this.isClosing || !this.el.open) {
      this.open();
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }
  shrink() {
    this.isClosing = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;
    if (this.animation) {
      this.animation.cancel();
    }
    this.animation = this.el.animate(
      {
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      },
      {
        duration: 400,
        easing: "ease-out"
      }
    );
    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => this.isClosing = false;
  }
  open() {
    this.el.style.height = `${this.el.offsetHeight}px`;
    this.el.open = true;
    window.requestAnimationFrame(() => this.expand());
  }
  expand() {
    this.isExpanding = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
    if (this.animation) {
      this.animation.cancel();
    }
    this.animation = this.el.animate(
      {
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      },
      {
        duration: 400,
        easing: "ease-out"
      }
    );
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => this.isExpanding = false;
  }
  onAnimationFinish(open) {
    this.el.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = this.el.style.overflow = "";
  }
}
document.querySelectorAll("details.accordion__wrapper").forEach((el) => {
  new Accordion(el);
});
export {
  enableLazyVideos as e
};
